// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_html2canvas_dist_html2canvas_js":"838cd2f73fed6412","node_modules_dompurify_dist_purify_es_mjs":"94c3c96257036983","node_modules_canvg_lib_index_es_js":"cd2ae2cfefe1d55b"}[chunkId] + ".js";
};